import { Link } from 'react-router-dom';

const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';

export default function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand column */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
              </div>
              <span className="text-lg font-bold text-white">Foam CaseBuilder</span>
            </Link>
            <p className="text-sm text-slate-400 mb-4 leading-relaxed">
              Foam CaseBuilder designs and manufactures custom foam inserts and advanced container solutions.
            </p>
            <div className="space-y-2 text-sm text-slate-400">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                1942 Broadway Street<br/>Boulder, CO 80302
              </div>
              <a href="tel:3033244953" className="flex items-center gap-2 hover:text-white transition-colors">
                <svg className="w-4 h-4 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                (303) 324-4953
              </a>
              <a href="mailto:sales@foamcasebuilder.com" className="flex items-center gap-2 hover:text-white transition-colors">
                <svg className="w-4 h-4 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                sales@foamcasebuilder.com
              </a>
            </div>
          </div>

          {/* Products column */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Products</h4>
            <ul className="space-y-2.5">
              <li><Link to="/products#protective" className="text-sm text-slate-400 hover:text-white transition-colors">Protective Cases</Link></li>
              <li><Link to="/products#rackmount" className="text-sm text-slate-400 hover:text-white transition-colors">Rackmount Cases</Link></li>
              <li><Link to="/products#shock-mount" className="text-sm text-slate-400 hover:text-white transition-colors">Shock Mount Cases</Link></li>
              <li><Link to="/design" className="text-sm text-slate-400 hover:text-white transition-colors">Custom Foam Inserts</Link></li>
              <li><Link to="/foam-guide" className="text-sm text-slate-400 hover:text-white transition-colors">Foam &amp; case guide</Link></li>
              <li><Link to="/design" className="text-sm text-slate-400 hover:text-white transition-colors">Foam CaseBuilder</Link></li>
            </ul>
          </div>

          {/* Industries column */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Industries</h4>
            <ul className="space-y-2.5">
              <li><Link to="/industries#aerospace" className="text-sm text-slate-400 hover:text-white transition-colors">Aerospace</Link></li>
              <li><Link to="/industries#medical" className="text-sm text-slate-400 hover:text-white transition-colors">Medical</Link></li>
              <li><Link to="/industries#military" className="text-sm text-slate-400 hover:text-white transition-colors">Military / Mil-Spec</Link></li>
              <li><Link to="/industries#government" className="text-sm text-slate-400 hover:text-white transition-colors">Government</Link></li>
              <li><Link to="/industries#telecom" className="text-sm text-slate-400 hover:text-white transition-colors">Telecommunications</Link></li>
              <li><Link to="/industries#industrial" className="text-sm text-slate-400 hover:text-white transition-colors">Industrial</Link></li>
              <li><Link to="/industries#video" className="text-sm text-slate-400 hover:text-white transition-colors">Video Equipment</Link></li>
            </ul>
          </div>

          {/* Company column */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Company</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-slate-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/about#capabilities" className="text-sm text-slate-400 hover:text-white transition-colors">Capabilities</Link></li>
              <li><Link to="/gallery" className="text-sm text-slate-400 hover:text-white transition-colors">Project Gallery</Link></li>
              <li><Link to="/blog" className="text-sm text-slate-400 hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/shop" className="text-sm text-slate-400 hover:text-white transition-colors">Shop</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-400 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/faq" className="text-sm text-slate-400 hover:text-white transition-colors">FAQ</Link></li>
            </ul>

            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mt-8 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/tutorial" className="text-sm text-slate-400 hover:text-white transition-colors">Step-by-step tutorial</Link></li>
              <li><Link to="/design" className="text-sm text-slate-400 hover:text-white transition-colors">Design Tool</Link></li>
              <li><Link to="/editor" className="text-sm text-slate-400 hover:text-white transition-colors">Foam Editor</Link></li>
              <li><Link to="/designs" className="text-sm text-slate-400 hover:text-white transition-colors">My Designs</Link></li>
              <li><Link to="/login" className="text-sm text-slate-400 hover:text-white transition-colors">Sign In</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <span>&copy; {new Date().getFullYear()} Foam CaseBuilder | Boulder, CO 80302 | All Rights Reserved.</span>
          <span>v{APP_VERSION}</span>
        </div>
      </div>
    </footer>
  );
}
